window.addEventListener('load', function() {
    const cards = document.querySelectorAll('.itu-cards-icons-item');

    cards.forEach(card => {
        const modalContent = card.querySelector('.modal-content');
        const modalOverlay = card.querySelector('.modal-overlay');

        // Modals cachés au chargement de la page
        if (modalContent && modalOverlay) {
            modalContent.style.display = 'none';
            modalOverlay.style.display = 'none';
            modalContent.style.visibility = 'hidden';
            modalOverlay.style.visibility = 'hidden';
        }

        card.addEventListener('click', (event) => {
            if (modalContent && modalOverlay && modalContent.style.visibility !== 'visible') {
                modalContent.style.display = 'block';
                modalOverlay.style.display = 'block';
                modalContent.style.visibility = 'visible';
                modalOverlay.style.visibility = 'visible';
                document.body.classList.add('no-scroll');
                document.body.classList.add('no-hover'); // Ajoute la classe no-hover
                event.stopPropagation(); // Empêche la propagation de l'événement
            }
        });

        const closeModal = card.querySelector('.modal-close');
        if (closeModal) {
            closeModal.addEventListener('click', (event) => {
                event.stopPropagation();
                if (modalContent && modalOverlay) {
                    modalContent.style.display = 'none';
                    modalOverlay.style.display = 'none';
                    modalContent.style.visibility = 'hidden';
                    modalOverlay.style.visibility = 'hidden';
                    document.body.classList.remove('no-scroll');
                    document.body.classList.remove('no-hover'); // Retire la classe no-hover
                }
            });
        }

        if (modalOverlay) {
            modalOverlay.addEventListener('click', (event) => {
                event.stopPropagation(); // Empêche la propagation de l'événement
                if (event.target === modalOverlay) {
                    if (modalContent) {
                        modalContent.style.display = 'none';
                        modalOverlay.style.display = 'none';
                        modalContent.style.visibility = 'hidden';
                        modalOverlay.style.visibility = 'hidden';
                        document.body.classList.remove('no-scroll');
                        document.body.classList.remove('no-hover'); // Retire la classe no-hover
                    }
                }
            });
        }

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                const modals = document.querySelectorAll('.modal-content');
                const overlays = document.querySelectorAll('.modal-overlay');
                modals.forEach(modal => {
                    modal.style.display = 'none';
                    modal.style.visibility = 'hidden';
                });
                overlays.forEach(overlay => {
                    overlay.style.display = 'none';
                    overlay.style.visibility = 'hidden';
                });
                document.body.classList.remove('no-scroll');
                document.body.classList.remove('no-hover'); // Retire la classe no-hover
            }
        });
    });

    // Remplace les retours à la ligne par des tirets
    const paragraphs = document.querySelectorAll('.modal-content p.card-description');
    paragraphs.forEach(p => {
        // Remplace les retours à la ligne et les balises <br> par des tirets
        p.innerHTML = p.innerHTML.replace(/\n/g, ' - ').replace(/<br>/gi, ' - ');
    });
});

window.addEventListener('load', function() {
    document.body.classList.add('loaded');
});